import { css } from 'lit';

export default css`
  :host {
    display: inline-block;
    --stepper-width: 97.5px;
    --stepper-height: 32px;
    --stepper-bg: var(--surface-raised, #ffffff);
    --stepper-border: var(--sm-line, 1.5px) solid var(--color-secondary, #2594e3);
    --stepper-border-radius: var(--radius-sm, 8px);
    --divider-bg: var(--color-secondary, #2594e3);
    --divider-bg-filled: var(--color-dark-gray, #1c2321);
    --button-color: var(--on-surface, #1c2321);
    --button-color-disabled: var(--on-surface-subtle, #d7d4d2);
  }

  .stepper {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    width: var(--stepper-width);
    height: var(--stepper-height);
    border-radius: var(--stepper-border-radius);
    box-sizing: border-box;
    padding: 0 var(--spacing-sm, 12px);
    gap: var(--spacing-sm, 12px);
    flex-shrink: 0;
  }

  :host([disabled]) .stepper {
    opacity: 0.7;
    cursor: not-allowed;
  }

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    color: var(--button-color);
    transition: all var(--duration-base, 0.2s) var(--easing-ease, ease);
  }

  button:hover:not([disabled]),
  button.focus:not([disabled]) {
    color: var(--color-secondary, #2594e3);
  }

  button.press:not([disabled]) {
    transform: scale(0.95);
  }

  button:focus-visible {
    outline: 2px solid var(--color-secondary, #2594e3);
    outline-offset: 2px;
  }

  button[disabled] {
    color: var(--button-color-disabled);
    cursor: not-allowed;
  }

  ::slotted([slot="minus-icon"]),
  ::slotted([slot="plus-icon"]) {
    width: 18px;
    height: 18px;
    color: inherit;
  }

  .divider {
    width: var(--sm-line, 1.5px);
    height: var(--stepper-height);
    flex: none;
  }

  /* Outline Style */
  :host([style-type="outline"]) .stepper {
    background: var(--stepper-bg);
    border: var(--stepper-border);
  }

  :host([style-type="outline"]) .divider {
    background: var(--divider-bg);
  }

  /* Filled Style */
  :host([style-type="filled"]) .stepper {
    background: var(--color-gray-1, #f7f5f4);
    border: none;
  }

  :host([style-type="filled"]) .divider {
    background: var(--divider-bg-filled);
  }

  @media (max-width: 768px) {
    .stepper {
      width: 80px;
      height: 28px;
      padding: 0 var(--spacing-xs, 8px);
    }
    button, ::slotted([slot="minus-icon"]), ::slotted([slot="plus-icon"]) {
      width: 16px;
      height: 16px;
    }
  }
`;